import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseCardComponent } from '@fuse/components/card';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';

@Component({
  selector: 'app-testimonial-type03',
  standalone: true,
  imports: [MatIconModule, DecimalPipe, CurrencyPipe, DestinationListType01Component, MatTooltipModule,FuseCardComponent, RouterLink,HeadingSectionType01Component],
  templateUrl: './testimonial-type03.component.html',
  styleUrl: './testimonial-type03.component.scss'
})
export class TestimonialType03Component implements OnInit {

  public view: any = {
  }

  constructor(public _tfmService: TFMService, private route: ActivatedRoute) {
    
  }

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

      this._tfmService.getTestimonials(this.view.site.agencyID, this.view.site.siteID).then(res => {
        this.view.testimonials = res;
        // console.log(this.view.testimonials);
      });
    });
  }
}
